exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nav-left .logo {\n  line-height: 90px;\n  padding-left: 20px;\n  background-color: #002140;\n}\n.nav-left .logo img {\n  height: 35px;\n}\n.nav-left .logo h1 {\n  color: #ffffff;\n  font-size: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 0 0 10px;\n}\n.top-bg {\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100px);\n  background-color: #002140;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.top-bg .top-bg-img {\n  width: calc(30px);\n  height: calc(30px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js!./src/components/NavLeft/index.less
// module id = 2347
// module chunks = 0